// import BannerList from './BannerList';
// import BannerCreate from './BannerCreate';
// import BannerEdit from './BannerEdit';
// import LessonIcon from '@material-ui/icons/Class';
import VideoReportsList from './VideoReportList';
import Icon from '@material-ui/core/Icon';
import Box from '@material-ui/core/Box';

const videoReportResource = {
    list: VideoReportsList,
    // create: BannerCreate,
    // edit: BannerEdit,
    icon: () => <Icon><Box component="img" src='icons/video-report.svg' /></Icon>,
};

export default videoReportResource;